/** Mirrors the operator vocabulary the backend engine accepts - see report-builder-engine.ts. */
export const REPORT_FILTER_OPERATORS: { value: string; label: string; types: string[] }[] = [
  { value: 'eq', label: 'is', types: ['string', 'number', 'date', 'boolean', 'enum'] },
  { value: 'ne', label: 'is not', types: ['string', 'number', 'date', 'boolean', 'enum'] },
  { value: 'gt', label: '>', types: ['number', 'date'] },
  { value: 'gte', label: '>=', types: ['number', 'date'] },
  { value: 'lt', label: '<', types: ['number', 'date'] },
  { value: 'lte', label: '<=', types: ['number', 'date'] },
  { value: 'cont', label: 'contains', types: ['string'] },
  { value: 'starts', label: 'starts with', types: ['string'] },
  { value: 'ends', label: 'ends with', types: ['string'] },
  { value: 'isnull', label: 'is empty', types: ['string', 'number', 'date', 'boolean', 'enum'] },
  { value: 'notnull', label: 'is not empty', types: ['string', 'number', 'date', 'boolean', 'enum'] },
];

export class ReportBuilderFilter {
  column: string = '';
  operator: string = 'eq';
  value: string = '';
}

export class ReportBuilderAggregateSpec {
  column: string = '';
  fn: string = 'SUM';
}

export class ReportSpec {
  entity: string = '';
  columns: string[] = [];
  joins: string[] = [];
  filters: ReportBuilderFilter[] = [];
  groupBy: string[] = [];
  aggregates: ReportBuilderAggregateSpec[] = [];
  sort: string = '';
  direction: string = 'asc';
  limit: number = 500;
}

export class ReportResultColumn {
  key: string = '';
  label: string = '';
}

export class ReportResult {
  columns: ReportResultColumn[] = [];
  rows: any[] = [];
}
